import React, { useContext, useState, useEffect } from "react";
import { Context } from "../../../Context";
import { UserAdministrationNewView } from "../../views";
import { SimpleLoading, ModalUtil } from "../../pures";
import { LocalStorageService, UserService } from "../../../services";
import { useTranslation } from "react-i18next";
import "moment/locale/es";
import { use } from "react";

/**
 * @class UserAdministrationNewAction
 * @extends {React.Component}
 * @status no delete
 */
const UserAdministrationNewAction = (props) => {
  const [initialLoading, setInitialLoading] = useState(true)
  const [users, setUsers] = useState([])
  const [roles, setRoles] = useState([])
  const [selectedUser, setSelectedUser] = useState({})

  const url = process.env.REACT_APP_ETICKET_API;
  const localStorageService = new LocalStorageService();
  const userService = new UserService(url)
  const token = localStorageService.getLocalStorageItem("token").idToken
  const modalUtil = new ModalUtil()
  const { t: tCommon } = useTranslation()
  const { t } = useTranslation("user-administration")

  const updateUserStatus = async (userStatus, email) => {
    modalUtil.showModal('loading', tCommon("modal.pure.loading.message"), tCommon("modal.pure.loading.title"))

    try {
      const response = await userService.updateUserStatus(token, { email, status: userStatus })
      if (response.statusCode === 200) {
        await modalUtil.showModal('success', t("updateUserStatusSuccess"), tCommon("modal.pure.title.success"))
        getInfoUsers()
      } else {
        throw new Error(t("updateUserStatusError"))
      }
    } catch (e) {
      console.log(e)
      modalUtil.showModal('error', e.message || 'Error al actualizar usuario', tCommon("modal.pure.title.error"))
    }
  }

  const createNewUser = async (email) => {
    modalUtil.showModal('loading', tCommon("modal.pure.loading.message"), tCommon("modal.pure.loading.title"))

    try {
      const newUser = await userService.createNewUserCollaborator(token, email)
      if (newUser.statusCode === 200) {
        await modalUtil.showModal('success', t('createUserSuccess'), tCommon("modal.pure.title.success"))
        getInfoUsers()
      } else if (newUser.statusCode == -2) {
        throw new Error(t("userAlreadyRegistered"))
      } else {
        throw new Error(t(newUser.message) || newUser.message || t("createUserError"))
      }
    } catch (e) {
      console.log(e)
      modalUtil.showModal('error', e.message || t('createUserError'), tCommon("modal.pure.title.error"))
    }
  }

  const updateUserRoles = async (roleIds) => {
    modalUtil.showModal('loading', tCommon("modal.pure.loading.message"), tCommon("modal.pure.loading.title"))

    try {
      const response = await userService.updateUserRoles(token, { userId: selectedUser.id, roles: roleIds })
      if (response.statusCode === 200) {
        await modalUtil.showModal('success', t("updateRolesSuccess"), tCommon("modal.pure.title.success"))
        getInfoUsers()
      } else if (response.statusCode == -2) {
        throw new Error(t("cannotDeleteAdmins"))
      } else {
        throw new Error(t("updateRolesError"))
      }
    } catch (e) {
      console.log(e)
      modalUtil.showModal('error', e.message || t("updateRolesError"), tCommon("modal.pure.title.error"))
      throw e
    }
  }

  const updateUserPermissions = async (permissionIds) => {
    modalUtil.showModal('loading', tCommon("modal.pure.loading.message"), tCommon("modal.pure.loading.title"))

    try {
      const response = await userService.updateUserPermissions(token, {
        userId: selectedUser.id,
        permissionIds
      })
      if (response.statusCode === 200) {
        await modalUtil.showModal('success', t("updatePermissionsSuccess"), tCommon("modal.pure.title.success"))
        getInfoUsers()
      } else if (response.statusCode == -2) {
        throw new Error(t("cannotModifyAdminPermissions"))
      } else {
        throw new Error(t("updatePermissionsError"))
      }
    } catch (e) {
      console.log(e)
      modalUtil.showModal('error', e.message || t("updatePermissionsError"), tCommon("modal.pure.title.error"))
      throw e
    }
  }

  const getInfoUsers = async () => {
    let usersCollaboratorAdmin = await userService.getUsersCollaboratorAdmin(token)
    console.log('Users from service:', usersCollaboratorAdmin)
    if (usersCollaboratorAdmin.length === 0) {
      setUsers([])
      return
    }

    const enrichedUsers = usersCollaboratorAdmin.map(user => {
      return {
        ...user,
        status: user.active ? t("active") : t("inactive"),
        name: `${user.firstName} ${user.firstLastName} ${user.secondLastName} `,
        permissions: user.permissions || []
      }
    })
    
    setUsers(enrichedUsers)

    if (selectedUser?.id) {
      const updatedUser = enrichedUsers.find(u => u.id === selectedUser.id)
      if (updatedUser) {
        setSelectedUser(updatedUser)
      } else {
        // if the user is no longer in the list, clear the selection
        setSelectedUser({})
      }
    }
  }

  const getInfoRoles = async () => {
    const data = await userService.getRolesAssignView(token)
    setRoles(data)
  }

  const getInfo = async (includeRoles = false) => {
    try {
      setInitialLoading(true)
      await getInfoUsers()
      if (includeRoles) await getInfoRoles()
      setInitialLoading(false)
    } catch (e) {
      console.log(e)
      modalUtil.showModal('error', e.message || t("loadingError"), tCommon("modal.pure.title.error"))
    }
  }

  useEffect(() => {
    getInfo(true)
  }, [])

  return (
    <>
      {
        initialLoading
          ? <div className="loading">
            <SimpleLoading />
          </div>
          : <UserAdministrationNewView
            t={t}
            users={users}
            setData={setUsers}
            roles={roles}
            initialLoading={initialLoading}
            createNewUser={createNewUser}
            updateUserStatus={updateUserStatus}
            updateUserRoles={updateUserRoles}
            updateUserPermissions={updateUserPermissions}
            selectedUser={selectedUser}
            setSelectedUser={setSelectedUser}
          />
      }
    </>
  )
}

function UserAdministrationNewContainer(props) {
  const { t } = useTranslation();
  const { setShowError } = useContext(Context);
  return (
    <UserAdministrationNewAction {...props} t={t} setShowError={setShowError} />
  );
}

export { UserAdministrationNewContainer as default };
